<template>
<!-- 公众号使用说明 -->
    <div class="gzhInstruction">
        <h2>公众号使用说明</h2>
        <div class="schedule">
            <div>
                <span>1</span>
                <p class="xian"></p>
                <span>关注公众号</span>
            </div>
            <div>
                <span>2</span>
                <span>进入公众号</span>
            </div>
            <div>
                <span>3</span>
                <span>点击设备管理</span>
            </div>
            <div class="words">
                <p>设备共享</p>
                <p>设备使用及统计情况</p>
            </div>
            <div>
                <span>4</span>
                <span>点击个人中心</span>
            </div>
            <div class="words justOneP">
                <p>(可添加修改个人信息)</p>
            </div>
            <div class="five">
                <span>5</span>
                <span>点击使用人信息</span>
            </div>
            <div class="words justOneP langP">
                <p>(可新建、查看个人信息)</p>
            </div>
            <div class="six">
                <span>6</span>
                <span>点击三大服务</span>
            </div>
            <div class="words justOneP langP shortP">
                <p>(专家咨询)</p>
            </div>
            <div class="seven">
                <span>7</span>
                <span>点击积分管理</span>
            </div>
            <div class="words more">
                <p>积分获取规则</p>
                <p>积分使用</p>
                <p>获取积分详情</p>
            </div>
            <div class="eight">
                <span>8</span>
                <span>点击售后服务</span>
            </div>
            <div class="words eightP">
                <p>(售后咨询)</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>

.gzhInstruction {
    margin: 28px;
    padding: 30px;
    background: #ffffff;
    border-radius: 25px;
    color: #ffffff;
    height: 1158px;
}

.gzhInstruction h2 {
    background: #39495c;
    text-align: center;
    height: 96px;
    line-height: 96px;
    border-radius: 25px;
}

.schedule {
    margin: 0 90px;
}

.schedule div {
    position: relative;
    padding-top: 52px;
    margin-bottom: 20px;
}
.schedule div.five {
    bottom: 30px;
}
.schedule div.six {
    bottom: 60px;
}
.schedule div.seven {
    bottom: 90px;
}
.schedule div.eight {
    bottom: 30px;
}

.schedule div:nth-of-type(8) {
    bottom: 30px;
}
.schedule div.words p{
    font-size: 34px;
    text-align: center;
    color: #333333;
    position: absolute;
    left: 100px;
}
.schedule div.words p:first-of-type {
    bottom: -20px;
    left: 180px;
}

.schedule div.justOneP p:first-of-type {
    left: 90px;
}

.schedule div.langP p:first-of-type {
    left: 76px;
}

.schedule div.shortP p:first-of-type {
    left: 166px;
    bottom: 34px;
}

.schedule div.more p:first-of-type {
    left: 156px;
    bottom: 60px;
}
.schedule div.more p:nth-of-type(2) {
    left: 180px;
    bottom: 20px;
}
.schedule div.more p:last-of-type {
    left: 156px;
    bottom: -20px;
}
.schedule div.eightP p:first-of-type {
    left: 166px;
    bottom: 2px;
}

.schedule div p:last-of-type {
    bottom: -62px;
}

.schedule div span {
    color: #ffffff;
    position: absolute;
    display: inline-block;
    background: #39495c;
    font-size: 34px;
}

.schedule div span:first-of-type {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    line-height: 46px;
    text-align: center;
    z-index: 2;
}


.schedule .xian {
    position: absolute;
    left: 20px;
    top: 0;
    width: 6px;
    height: 986px;
    background: #39495c;
}

.schedule div span:last-of-type {
    width: 294px;
    height: 46px;
    border-radius: 25px;
    line-height: 46px;
    text-align: center;
    z-index: 2;
    left: 100px;
}


</style>



// WEBPACK FOOTER //
// src/views/GZHInstructions.vue